import React from 'react';
import PropTypes from 'prop-types';
import useProfileSx from '../hooks/useProfileSx';
import ProfileOrganisationSearchableSelect from './ProfileOrganisationSearchableSelect';

export default function ProfileOrgFilter({ value, onChange, inline = false, sx }) {
  const styles = useProfileSx();

  return (
    <ProfileOrganisationSearchableSelect
      label={inline ? undefined : 'Organisation'}
      selectedOrganisation={value || null}
      valueId={value?.organisation_id ?? null}
      onChange={onChange}
      placeholder={inline ? 'All organisations' : undefined}
      sx={sx ?? (inline ? styles.tableFilters?.orgFilter : styles.orgFilter)}
    />
  );
}

ProfileOrgFilter.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
  inline: PropTypes.bool,
  sx: PropTypes.object,
};
